import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35f3a2c1"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=35f3a2c1&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f3a2c1')) {
      api.createRecord('35f3a2c1', component.options)
    } else {
      api.reload('35f3a2c1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=35f3a2c1", function () {
      api.rerender('35f3a2c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TopNav/index.vue"
export default component.exports